import { IS_MOBILE, Is_TAB } from "const/common";
import Image from "next/image";
import { useEffect, useState } from "react";

const About = () => {
  const [isMobile, setIsMobile] = useState();
  const [isTab, setIsTab] = useState(false);
  useEffect(() => {
    setIsMobile(IS_MOBILE(600));
    setIsTab(Is_TAB(1079));
  }, []);

  return (
    <>
      <div className="pt-16 px-4 xl:px-16 pb-40">
        <div className="bg-gray-200 bg-opacity-50 py-12 pl-12 md:pt-12 md:pl-12 md:pb-0 xl:py-12 rounded-3xl">
          <div className="flex flex-col md:flex-row flex-wrap justify-between">
            <div className="border border-solid border-y-0 border-r-0 border-gray-300 h-12 mb-16 xl:mb-0 w-full md:w-1/2 xl:w-3/12 px-3">
              <div className="flex flex-col items-baseline">
                <h2 className="text-sm font-light text-black text-left mb-2">
                  <span className="font-lato">PROJECT TYPE</span>
                </h2>
                <span className="text-base font-normal text-black text-center font-lato">
                  MVP: UI/UX Design & App Devlopment
                </span>
              </div>
            </div>
            <div className="border border-solid border-y-0 border-r-0 border-gray-300 h-12 mb-16 xl:mb-0 w-full md:w-1/2 xl:w-3/12 px-3">
              <div>
                <h2 className="text-sm font-light text-black text-left mb-2">
                  <span className="font-lato">CLIENT</span>
                </h2>
                <span className="text-base font-normal text-black text-center font-lato">
                  Know Your Customer, Australia
                </span>
              </div>
            </div>
            <div className="border border-solid border-y-0 border-r-0 border-gray-300 h-12 mb-16 xl:mb-0 w-full md:w-1/2 xl:w-3/12 px-3">
              <div>
                <h2 className="text-sm font-light text-black text-left mb-2">
                  <span className="font-lato">INDUSTRY</span>
                </h2>
                <span className="text-base font-normal text-black text-center font-lato">
                  Social Networking
                </span>
              </div>
            </div>
            <div className="border border-solid border-y-0 border-r-0 border-gray-300 h-12 mb-16 xl:mb-0 w-full md:w-1/2 xl:w-3/12 px-3">
              <div>
                <h2 className="text-sm font-light text-black text-left mb-2">
                  <span className="font-lato">TECHNICAL STACKS</span>
                </h2>
                <span className="text-base font-normal text-black text-center font-lato">
                  React, Node, Flutter
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-3/5 -mt-8 mx-auto">
          <div className="relative w-fit">
            <Image
              alt="roundtext"
              src="/assets/case-study/kyc/round-text.webp"
              className="animate-custom-spin w-24 md:w-32 xl:w-40"
              width={160}
              height={160}
            />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <Image
                alt="arrow"
                className="w-8 md:w-10 xl:w-auto"
                src="/assets/case-study/kyc/cross-arrow.webp"
                width={50}
                height={62}
              />
            </div>
          </div>
        </div>
        <div className="text-center pt-16 pb-32 xl:px-32">
          <span className="font-medium leading-loose text-base md:text-xl md:leading-loose xl:text-5xl xl:leading-loose font-ubuntu text-black text-center">
            A collaborative review&nbsp;&nbsp;
            <span className="inline-block w-12 h-12 xl:w-auto xl:h-auto">
              <Image
                alt="Woman smiling"
                src="/assets/case-study/kyc/profile-image.webp"
                className="!rounded-full"
                width={128}
                height={128}
              />
            </span>
            &nbsp;platform open to every service/goods provider across numerous
            professions that informs, warns and saves
            <span className="w-[90px] h-7 xl:w-44 xl:h-12 bg-gradient-kyc-about rounded-10 p-4 relative inline-block top-2.5 mx-4 [&_span]:!w-5 [&_span]:!h-5 [&_span]:xl:!h-10 [&_span]:xl:!w-10">
              <div className="absolute rounded-xl transition-all duration-500 animate-identifier-mobile xl:animate-identifier top-1 md:-top-0.5 xl:-top-6">
                <Image
                  alt="emote"
                  src="/assets/case-study/kyc/emote.webp"
                  width={40}
                  height={40}
                  layout="fixed"
                />
              </div>
            </span>
            time interacting with &apos;dodgy&apos; clients.
          </span>
        </div>
      </div>
      <div className="bg-black h-[40vh] xl:h-[70vh] relative flex justify-center">
        <div className="text-center w-fit mx-auto absolute -top-60">
          <Image
            alt="
            KYC App showing user's rating and reviews"
            src="/assets/case-study/kyc/rating-mockup.webp"
            width={660}
            height={667}
          />
        </div>
      </div>
      <div className="pr-4 pb-16 xl:px-16 bg-black">
        <div className="flex">
          <div className="w-20 xl:w-32 bg-black z-10 relative left-6 xl:left-10 rounded-tr-10">
            <Image
              alt="Man working in kitchen"
              className="w-16 xl:w-auto"
              src="/assets/case-study/kyc/reviews-profile.webp"
              width={98}
              height={97}
            />
          </div>
          <div className="w-3/4 xl:w-1/2 bg-[#141414] py-8 xl:py-16 px-4 xl:px-8 rounded-lg">
            <h3 className="text-base md:text-xl xl:text-3xl font-medium text-white ml-12 mb-2">
              <span className="font-ubuntu">The Concept</span>
            </h3>
            <p className="text-xs md:text-base xl:text-lg font-medium text-white ml-12 mb-4">
              <span className="font-ubuntu">
                As “customers,” we generally provide feedback or reviews to the
                services, places, or goods we buy because we believe that
                sharing our valuable experience with others will help them
                choose a better option when needed.
              </span>
            </p>
            <p className="text-xs md:text-base xl:text-lg font-medium text-white ml-12 mb-4">
              <span className="font-ubuntu">
                Vice versa, our Client wanted to come up with a platform where
                he can help all service providers to know about their customers
                before working or collaborating with them!
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="pl-4 xl:pr-24 xl:pb-16 xl:pl-16 bg-black">
        <div className="flex justify-end">
          <div className="w-3/4 xl:w-1/2 bg-[#141414] py-8 px-4 xl:py-16 xl:px-8 rounded-lg">
            <h3 className="text-base md:text-xl xl:text-3xl font-medium text-white mr-12 mb-2">
              <span className="font-ubuntu">
                It’s for every Service providers
              </span>
            </h3>
            <ul className="pl-4 list-disc mb-4">
              <li className="text-xs md:text-base xl:text-lg font-normal text-white my-8 mr-8">
                <span className="font-ubuntu">
                  Contractors and Subcontractors within the construction
                  industry (Plumbers, Electricians, Tilers, Carpenters, Brick
                  Layers, or any other construction-orientated installation
                  service, etc.)
                </span>
              </li>
              <li className="text-xs md:text-base xl:text-lg font-normal text-white my-8 mr-8">
                <span className="font-ubuntu">
                  Small to medium suppliers of materials (Catering companies,
                  Wedding Management, Performers, Food wholesalers, etc.)
                </span>
              </li>
              <li className="text-xs md:text-base xl:text-lg font-normal text-white my-8 mr-8">
                <span className="font-ubuntu">
                  Suppliers of medical goods and services (Physiotherapists,
                  Chiropractors, Beauty Therapist, Remedial massage, surgeons)
                </span>
              </li>
              <li className="text-xs md:text-base xl:text-lg font-normal text-white my-8 mr-8">
                <span className="font-ubuntu">
                  Home maintenance service suppliers
                </span>
              </li>
            </ul>
          </div>
          <div className="w-20 xl:w-32 bg-black z-10 relative right-6 xl:right-10 rounded-tl-10 pl-4 xl:pl-8">
            <Image
              alt="Woman making coffee"
              className="w-16 xl:w-auto"
              src="/assets/case-study/kyc/coffee-girl.webp"
              width={98}
              height={97}
            />
          </div>
        </div>
      </div>
      <div className="pt-32 pr-16 pb-8 pl-16 xl:py-64 xl:px-16 bg-black relative">
        <div className="flex justify-center">
          <h2 className="absolute text-3xl xl:text-6xl font-medium text-white xl:pt-16 top-20 text-center">
            <span className="font-ubuntu">
              Major Frustrations of
              <br />
              Service Providers
            </span>
          </h2>
        </div>
      </div>
      {isMobile || isTab ? (
        <div className="block xl:hidden">
          <div className="relative xl:pt-[28rem] bg-black overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <div className="pt-12 px-8 pb-8 md:py-12 w-full md:w-1/2">
                <div className="bg-white/10 rounded-xl p-4 w-72">
                  <p className="text-xs md:text-lg font-light text-white pl-4">
                    <span className="font-ubuntu">
                      Not getting the payment on time or at all.
                    </span>
                  </p>
                </div>
                <div className="bg-white/10 rounded-xl p-4 w-72 py-8 px-12 xl:px-16 my-8 mx-12">
                  <p className="text-xs md:text-lg font-light text-white pl-4">
                    <span className="font-ubuntu">
                      Not keeping to agreed appointments or correspondence.
                    </span>
                  </p>
                </div>
                <div className="bg-white/10 rounded-xl p-4 w-72">
                  <p className="text-xs md:text-lg font-light text-white pl-4">
                    <span className="font-ubuntu">
                      Overall negative interaction attitude/demeanour.
                    </span>
                  </p>
                </div>
              </div>
              <div className="px-8 pb-8 xl:pt-14 xl:pb-12 xl:pl-24 w-full md:w-1/2">
                <div className="bg-white/10 rounded-xl p-4 w-72 py-8 px-12 xl:px-16">
                  <p className="text-xs md:text-lg font-light text-white pl-4">
                    <span className="font-ubuntu">
                      Receiving False claims of a damaged property while
                      supplying goods and services.
                    </span>
                  </p>
                </div>
                <div className="bg-white/10 rounded-xl p-4 w-72 py-8 px-12 xl:px-16 my-8 mx-12">
                  <p className="text-xs md:text-lg font-light text-white pl-4">
                    <span className="font-ubuntu">
                      Lack of communication – clear articulation/description of
                      the scope of supply.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center relative -top-4 bg-black py-16 px-4">
            <Image
              alt="frustratedmen"
              src="/assets/case-study/kyc/frustration-responsive.webp"
              width={464}
              height={655}
            />
          </div>
        </div>
      ) : (
        <div className="hidden xl:block relative w-full pb-48">
          <div className="mx-8 bg-bright-navy-blue rounded-10 -mt-48 h-[28rem]">
            <div className="flex">
              <div className="pt-14 pb-12 pl-24 w-4/12">
                <div className="bg-white/10 rounded-xl p-4 w-80">
                  <p className="text-lg font-light text-white pl-4">
                    Not getting the payment on time or at all.
                  </p>
                </div>
                <div className="bg-white/10 rounded-xl p-4 w-80 my-8 mx-16">
                  <p className="text-lg font-light text-white pl-4">
                    Not keeping to agreed appointments or correspondence.
                  </p>
                </div>
                <div className="bg-white/10 rounded-xl p-4 w-80">
                  <p className="text-lg font-light text-white pl-4">
                    Overall negative interaction attitude/demeanour.
                  </p>
                </div>
              </div>
              <div className="w-4/12">
                <div className="flex justify-center relative -top-16">
                  <Image
                    alt=" Frustrated man"
                    className="h-[32rem]"
                    src="/assets/case-study/kyc/frustrated-men.webp"
                    width={363}
                    height={512}
                  />
                </div>
              </div>
              <div className="pt-20 pb-12 pr-12 w-4/12">
                <div className="bg-white/10 rounded-xl p-4 w-80">
                  <p className="text-lg font-light text-white pl-4">
                    Receiving False claims of a damaged property while supplying
                    goods and services.
                  </p>
                </div>
                <div className="bg-white/10 rounded-xl -4 w-80 my-8 mx-16">
                  <p className="text-lg font-light text-white pl-4">
                    Lack of communication – clear articulation/description of
                    the scope of supply.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default About;
